export default {
  nav: {
    home: "Hjem",
    spreadsheet: "Regneark",
    categories: "Kategorier",
    guides: "Guider",
    comparisons: "Sammenligninger",
    safety: "Sikkerhed",
    faq: "FAQ",
    search: "Søg",
    language: "Sprog",
    cta: "Udforsk Regneark",
  },
  categories: {
    shoes: "Sko",
    hoodies: "Hættetrøjer / Sweaters",
    tshirts: "T-Shirts",
    jackets: "Jakker",
    pants: "Bukser / Shorts",
    headwear: "Hovedbeklædning",
    sets: "Sæt",
    underwear: "Undertøj",
    jersey: "Trøjer",
    accessories: "Accessories",
    bags: "Tasker",
    belts: "Bælter",
    perfumes: "Parfumer",
    other: "Andre Ting",
  },
  hero: {
    eyebrow: "ALLCHINABUY FORSKNINGS-CENTER",
    h1: "AllChinaBuy Spreadsheet — Find Produkter, Sælgere og Købsressourcer Hurtigere",
    subheadline: "Udforsk AllChinaBuy-regnearket, produktforskningsguider, sælgerressourcer, QC-tip, forsendelsesoplysninger og de seneste købsressourcer — alt organiseret ét sted.",
    ctaPrimary: "Udforsk AllChinaBuy Spreadsheet",
    ctaSecondary: "Gennemse Købsguider",
    trust: "Opdaterede ressourcer • Produktsøgning • QC-guider • Forsendelsesoplysninger • Sikkerhedsressourcer",
    searchPlaceholder: "Søg efter produkter, sælgere, forsendelsesguider eller AllChinaBuy-ressourcer...",
  },
  valueProp: {
    h2: "Alt Du Behøver for at Forske i AllChinaBuy Produkter",
    copy: "At finde produkter er kun det første skridt. Vores AllChinaBuy ressource-hub hjælper dig med at forske i produkter, sammenligne muligheder, forstå QC-oplysninger, udforske forsendelsesmetoder og træffe bedre informerede købsbeslutninger.",
    cta: "Udforsk Alle Ressourcer",
    cards: {
      spreadsheet: {
        title: "AllChinaBuy Spreadsheet",
        desc: "Find organiserede produkt- og forskningsressourcer.",
      },
      research: {
        title: "Produktsøgning",
        desc: "Lær hvordan du evaluerer produkter før bestilling.",
      },
      sellers: {
        title: "Sælgerguider",
        desc: "Forstå sælgeroplysninger og produktudvælgelse.",
      },
      qc: {
        title: "QC Ressourcer",
        desc: "Lær hvad du skal se efter ved gennemgang af kvalitetskontroloplysninger.",
      },
      shipping: {
        title: "Forsendelsesguider",
        desc: "Forstå forsendelsesmuligheder, omkostninger og vigtige overvejelser.",
      },
      safety: {
        title: "Sikkerhedscenter",
        desc: "Lær praktiske måder at reducere almindelige købs- og sikkerhedsrisici på.",
      },
    },
  },
  spreadsheetPreview: {
    h2: "AllChinaBuy Spreadsheet",
    copy: "AllChinaBuy-regnearket er den centrale ressource til at opdage produkter, organisere forskning og finde nyttige købsoplysninger. Brug det som udgangspunkt, og udforsk derefter vores detaljerede guider, før du træffer købsbeslutninger.",
    cta: "Åbn AllChinaBuy Spreadsheet",
    columns: {
      product: "Produkt",
      category: "Kategori",
      seller: "Sælger",
      status: "Forskningsstatus",
      qc: "QC Ressource",
      guide: "Guide",
      updated: "Opdateret",
    },
  },
  trust: {
    h2: "Hvorfor Bruge Dette AllChinaBuy Ressource-Center?",
    cards: {
      organized: {
        title: "Organiseret Forskning",
        desc: "Ressourcer er grupperet efter produkt, kategori, sælger, QC, forsendelse og købsintention.",
      },
      comparisons: {
        title: "Nyttige Sammenligninger",
        desc: "Klare tabeller hjælper brugere med at forstå forskellene mellem muligheder.",
      },
      updated: {
        title: "Opdateret Indhold",
        desc: "Vis udgivelses- og opdateringsdatoer.",
      },
      safetyFirst: {
        title: "Sikkerhed Først",
        desc: "Giv praktisk information om produktsøgning, betalinger, konti og forsendelse.",
      },
      multilingual: {
        title: "Flersproget",
        desc: "Versioner på engelsk, fransk, dansk og tysk.",
      },
      independent: {
        title: "Uafhængig Ressource",
        desc: "Angiv tydeligt sitets forhold til hovedwebstedet, hvor det er relevant.",
      },
    },
  },
  comparison: {
    h2: "AllChinaBuy Ressourcer Overblik",
    cta: "Udforsk det Fuldendte Ressource-Center",
    headers: {
      resource: "Ressource",
      bestFor: "Bedst Til",
      info: "Information",
    },
    rows: {
      spreadsheet: { name: "AllChinaBuy Spreadsheet", bestFor: "Produktopdagelse", info: "Produkter & forskning" },
      productGuides: { name: "Produktguider", bestFor: "Produktsøgning", info: "Købsovervejelser" },
      qcGuides: { name: "QC Guider", bestFor: "Kvalitetskontrol", info: "QC principper" },
      shippingGuides: { name: "Forsendelsesguider", bestFor: "Forsendelsesforskning", info: "Metoder & faktorer" },
      warehouseGuide: { name: "Lager Guide", bestFor: "Lageroplysninger", info: "Opbevaring & behandling" },
      safetyGuide: { name: "Sikkerheds Guide", bestFor: "Risikobevidsthed", info: "Sikkerhed & tryghed" },
    },
  },
  reviewSection: {
    h2: "AllChinaBuy Anmeldelse: Hvad Bør Købere Vide?",
    copy: "Inden du bruger en købsplatform, er det vigtigt at forstå, hvordan produktsøgning, bestilling, QC, lagerbehandling og forsendelse fungerer. Vores AllChinaBuy anmeldelsesindhold fokuserer på praktisk information frem for usunderbyggede påstande.",
    cta: "Læs AllChinaBuy Anmeldelsen",
  },
  shippingSection: {
    h2: "AllChinaBuy Forsendelsesomkostning & Forsendelsesguide",
    copy: "Forsendelsesomkostninger kan variere afhængigt af destination, pakkestørrelse, vægt, forsendelsesmetode og andre faktorer. Lær hvordan forsendelse fungerer, hvad der kan påvirke den endelige pris, og hvordan du sammenligner tilgængelige muligheder.",
    cta: "Se AllChinaBuy Forsendelsesguide",
  },
  couponSection: {
    h2: "AllChinaBuy Kupon & Rabatkode",
    copy: "Leder du efter AllChinaBuy kuponer eller rabatkoder? Tjek vores seneste kupon- og promotionsressourcer, før du bestiller. Bekræft altid, om et tilbud er aktuelt, gyldigt og underlagt specifikke betingelser.",
    cta: "Tjek Kuponer & Rabatter",
  },
  warehouseSection: {
    h2: "AllChinaBuy Lager Guide",
    copy: "Forstå hvordan lageropbevaring, produktinspektion, behandling og forsendelsesforberedelse passer ind i købsprocessen.",
    cta: "Udforsk Lager Guiden",
  },
  safetySection: {
    h2: "Er AllChinaBuy Lovlig & Sikker?",
    copy: "At undersøge, om en platform er lovlig, bør indebære mere end et simpelt ja- eller nej-svar. Lær, hvad du skal tjekke, hvordan du beskytter din konto og betalingsoplysninger, hvordan du evaluerer produktoplysninger, og hvilke risici du bør overveje, før du bestiller.",
    cta: "Læs AllChinaBuy Sikkerhedsguide",
  },
  finalCta: {
    h2: "Start med AllChinaBuy Regnearket",
    copy: "Forske i produkter. Sammenligne muligheder. Forstå QC og forsendelse. Træffe bedre informerede købsbeslutninger.",
    ctaPrimary: "Udforsk AllChinaBuy Spreadsheet",
    ctaSecondary: "Læs Begynderguiden",
  },
  categoryButtons: {
    h2: "Gennemse AllChinaBuy Kategorier",
    copy: "Spring direkte til din yndlingsproduktkategori på hovedbutikken.",
  },
  productShowcase: {
    h2: "Udvalgte Produkter",
    copy: "Gennemse kuraterede produkter fra AllChinaBuy-regnearket. Klik på ethvert element for at se detaljer og købe i hovedbutikken.",
    viewAll: "Se Alle {{category}}",
  },
  productCard: {
    buyNow: "Køb Nu",
  },
  productDetail: {
    notFound: "Produkt Ikke Fundet",
    notFoundDesc: "Det produkt, du leder efter, findes ikke eller er blevet fjernet.",
    backHome: "Tilbage til Hjem",
    verified: "Verificeret Produktliste",
    qcAvailable: "QC Billeder Tilgængelige",
    shippingGlobal: "Globale Forsendelsesmuligheder",
    buyNow: "Køb Nu — Gå til Butik",
    viewCategory: "Se Alle i Kategori",
    redirectNotice: "Du vil blive omdirigeret til den officielle butik for at gennemføre dit køb.",
    relatedTitle: "Du Vil Måske Også Synes Om",
  },
  ctaButtons: {
    allchinabuy: "AllChinaBuy Spreadsheet",
    buyNow: "Køb Nu",
  },
  footer: {
    tagline: "AllChinaBuy Spreadsheet — Dit forskningscenter til smartere købsbeslutninger.",
    links: {
      about: "Om",
      privacy: "Privatliv",
      terms: "Vilkår",
      contact: "Kontakt",
    },
    copyright: "© 2026 AllChinaBuy Spreadsheet. Alle rettigheder forbeholdt.",
  },
  lang: {
    en: "English",
    fr: "Français",
    da: "Dansk",
    de: "Deutsch",
  },
  article: {
    readMore: "Læs Fuld Guide",
    relatedArticles: "Relaterede Artikler",
  },
  faq: {
    h2: "Ofte Stillede Spørgsmål",
    q1: "Hvad er AllChinaBuy-regnearket?",
    a1: "AllChinaBuy-regnearket er en organiseret ressource, der hjælper købere med at opdage produkter, forske i sælgere, sammenligne muligheder og træffe informerede købsbeslutninger.",
    q2: "Hvordan bruger jeg AllChinaBuy-regnearket?",
    a2: "Start med at gennemse kategorierne, der matcher din interesse. Brug søgefunktionen til at finde specifikke produkter eller sælgere. Gennemgå QC- og forsendelsesguiderne, før du afgiver ordrer.",
    q3: "Er AllChinaBuy sikkert at bruge?",
    a3: "Sikkerhed afhænger af dine forskningspraksisser. Vores guider dækker kontobeskyttelse, betalingssikkerhed, produktevaluering og risikoreduktionsstrategier.",
    q4: "Hvor meget koster AllChinaBuy-forsendelse?",
    a4: "Forsendelsesomkostninger varierer efter destination, pakkevægt, dimensioner og valgt forsendelsesmetode. Se vores forsendelsesguide for detaljerede opdelinger.",
    q5: "Tilbyder AllChinaBuy kuponer eller rabatter?",
    a5: "Kuponer og kampagner kan være tilgængelige periodisk. Bekræft altid aktuelle tilbud og læs betingelserne, før du anvender en rabatkode.",
  },
};